module.exports = __webpack_public_path__ + "static/media/star-progress.32b2ab4a.mp3";